// Dhaba Service
// Handles all dhaba/restaurant related operations

import { api } from './api';
import { dhabas as mockDhabas } from '../data';

/**
 * Get nearby dhabas based on location
 * @param {Object} coords - {lat, lng}
 * @param {number} radiusKm - Search radius
 * @param {Object} filters - Optional filters
 */
export async function getNearbyDhabas(coords, radiusKm = 50, filters = {}) {
  try {
    let url = `/dhabas/nearby?lat=${coords.lat}&lng=${coords.lng}&radius=${radiusKm}`;
    
    if (filters.vegOnly) url += '&veg_only=true';
    if (filters.hasParking) url += '&has_parking=true';
    if (filters.hasWashroom) url += '&has_washroom=true';
    
    const response = await api.get(url);
    return response.dhabas || [];
  } catch (error) {
    console.error('Failed to fetch nearby dhabas:', error);
    // Fallback to mock data
    return mockDhabas;
  }
}

/**
 * Get all dhabas
 * @param {Object} filters - Optional filters (cuisine, isVeg, etc.)
 */
export async function getDhabas(filters = {}) {
  try {
    const response = await api.get('/dhabas/');
    return response.dhabas || [];
  } catch (error) {
    console.error('Failed to fetch dhabas:', error);
    return mockDhabas;
  }
}

/**
 * Get a single dhaba by ID
 */
export async function getDhabaById(id) {
  try {
    const response = await api.get(`/dhabas/${id}`);
    return response.dhaba || null;
  } catch (error) {
    console.error('Failed to fetch dhaba:', error);
    return mockDhabas.find(d => d.id === id) || null;
  }
}

/**
 * Get dhabas along a route
 * @param {Object} start - Start coordinates {lat, lng}
 * @param {Object} end - End coordinates {lat, lng}
 */
export async function getDhabasAlongRoute(start, end) {
  try {
    const response = await api.get(
      `/dhabas/route?start_lat=${start.lat}&start_lng=${start.lng}&end_lat=${end.lat}&end_lng=${end.lng}`
    );
    return response.dhabas || [];
  } catch (error) {
    console.error('Failed to fetch route dhabas:', error);
    return mockDhabas;
  }
}

/**
 * Get dhabas on a specific highway
 */
export async function getDhabasByHighway(highway) {
  try {
    const response = await api.get(`/dhabas/highway/${highway}`);
    return response.dhabas || [];
  } catch (error) {
    console.error('Failed to fetch highway dhabas:', error);
    return mockDhabas;
  }
}

export const dhabaService = {
  getDhabas,
  getDhabaById,
  getDhabasAlongRoute,
  getNearbyDhabas,
  getDhabasByHighway,
};

export default dhabaService;
